(() => {
  const BUSY_ATTR = "data-ajax-cart-busy";

  const setBusy = (isBusy) => {
    if (isBusy) {
      document.documentElement.setAttribute(BUSY_ATTR, "true");
    } else {
      document.documentElement.removeAttribute(BUSY_ATTR);
    }
  };

  document.addEventListener("liquid-ajax-cart:queue-start", () => setBusy(true));
  document.addEventListener("liquid-ajax-cart:queue-end", () => setBusy(false));

  document.addEventListener(
    "click",
    (event) => {
      if (!document.documentElement.hasAttribute(BUSY_ATTR)) return;

      const el = event.target instanceof Element ? event.target : null;
      if (!el) return;

      const actionable = el.closest(
        "[data-ajax-cart-request-button],[data-ajax-cart-quantity-plus],[data-ajax-cart-quantity-minus]",
      );
      if (!actionable) return;

      event.preventDefault();
      event.stopPropagation();
    },
    { capture: true },
  );
})();

